declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>;
    }
    var System: System;
}
import login from '../views/login.vue';
import home from '../views/home/home.vue';
import main from '../views/main.vue';

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue'),
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: '浦东人才服务',
    },
    component: () => import('../views/login.vue'),
};
export const externalDetail: Array<Router> = [
{
        path: "/householdDocumentProcessingFormDetailPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdDocumentProcessingFormDetailPhone",
        component: () => import("../views/mgr_phone/documentProcessingFormDetailPhone.vue"),
    },
    {
        path: "/householdDocumentProcessingFormDetailRQPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdDocumentProcessingFormDetailRQPhone",
        component: () => import("../views/mgr_phone/documentProcessingFormDetailRQPhone.vue"),
    },
    {
        path: "/householdArchiveDetailPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdArchiveDetailPhone",
        component: () => import("../views/mgr_phone/archivePhone.vue"),
    },
    {
        path: "/householdJZHEndSandOrderPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdJZHEndSandOrderPhone",
        component: () => import("../views/mgr_phone/sandOrderListPhone.vue"),
    },
     {
        path: "/householdRCYJEndSandOrderPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdRCYJEndSandOrderPhone",
        component: () => import("../views/mgr_phone/sandOrderListPhone.vue"),
    },
      {
        path: "/householdLXSEndSandOrderPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdLXSEndSandOrderPhone",
        component: () => import("../views/mgr_phone/sandOrderListPhone.vue"),
    },
       {
        path: "/householdJKEndSandOrderPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "householdJKEndSandOrderPhone",
        component: () => import("../views/mgr_phone/sandOrderListPhone.vue"),
    },
        {
        path: "/remindListPhone",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "remindListPhone",
        component: () => import("../views/mgr_phone/remindListPhone.vue"),
    },
     {
        path: "/businessAssistant",
        icon: "ios-flag",
        permission: "",
        meta: { title: "" },
        name: "businessAssistant",
        component: () => import("../views/mgr_phone/businessAssistant.vue"),
    },
]
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        {
            path: 'home',
            meta: { title: '首页' },
            name: 'home',
            component: () => import('../views/home/home.vue'),

        },
        {
            path: 'passwordReset',
            meta: { title: '密码重置' },
            name: 'passwordReset',
            component: () => import('../views/passwordReset/index.vue'),
        },
        {
            path: 'xinkaihu',
            meta: { title: '新开户' },
            name: 'xinkaihu',
            component: () => import('../views/xinkaihu/index.vue'),
        },
        {
            path: 'informationChanges',
            meta: { title: '信息变更' },
            name: 'informationChanges',
            component: () => import('../views/informationChanges/index.vue'),
        },
        {
            path: 'unitApplication',
            meta: { title: '单位变更' },
            name: 'unitApplication',
            component: () => import('../views/unitApplication/index.vue'),
        },
        {
            path: 'addresChange',
            meta: { title: '地址变更' },
            name: 'addresChange',
            component: () => import('../views/addresChange/index.vue'),
        },
        {
            path: 'cancelMyselfSpouseChildren',
            meta: { title: '注销申请人积分，配偶、子女信息' },
            name: 'cancelMyselfSpouseChildren',
            component: () => import('../views/cancelMyselfSpouseChildren/index.vue'),
        },
        {
            path: 'danweichehuishenqin',
            meta: { title: '单位撤回申请' },
            name: 'danweichehuishenqin',
            component: () => import('../views/danweichehuishenqin/index.vue'),
        },
      
    ],
};
export const appRouters: Array<Router> = [

    {
        path: '/residencePermitIntegral',
        name: 'residencePermitIntegral',
        permission: '',
        meta: { title: '居住证积分申请' },
        icon: 'md-barcode',
        component: main,
        children: [
            { path: '/pointsNewDetail', permission: '', icon: 'ios-flag', meta: { title: '积分新办申请详情' }, name: 'pointsNewDetail', component: () => import('../views/residencePermitIntegral/pointsNewDetail/newPoints.vue') },
            { path: '/renewalPoinsDetail', permission: '', icon: 'ios-flag', meta: { title: '积分续办申请详情' }, name: 'renewalPoinsDetail', component: () => import('../views/residencePermitIntegral/pointsNewDetail/renewalPoins.vue') },
            { path: '/addWithinValidityFamilyDetail', permission: '', icon: 'ios-flag', meta: { title: '有效期内添加同住人详情' }, name: 'addWithinValidityFamilyDetail', component: () => import('../views/residencePermitIntegral/addWithinValidityFamilyDetail/index.vue') },
            { path: '/pointsNew', permission: 'Pages.申请.新办申请', icon: 'ios-flag', meta: { title: '积分新办申请' }, name: 'pointsNew', component: () => import('../views/residencePermitIntegral/pointsNew/index.vue') },
            { path: '/pointsNewSupplement', permission: '', icon: 'ios-flag', meta: { title: '新办补充材料' }, name: 'pointsNewSupplement', component: () => import('../views/residencePermitIntegral/pointsNewSupplement/pointsNew.vue') },
            { path: '/renewalSupplement', permission: '', icon: 'ios-flag', meta: { title: '续办补充材料' }, name: 'renewalSupplement', component: () => import('../views/residencePermitIntegral/pointsNewSupplement/renewal.vue') },
            // { path: '/pointsRenew', permission: 'Pages.Users', icon: 'ios-flag', meta: { title: '积分续办申请' }, name: 'pointsRenew', component: () => import('../views/residencePermitIntegral/pointsRenew/index.vue') },
            { path: '/addWithinValidityFamily', permission: 'Pages.申请.添加同住人申请', icon: 'ios-flag', meta: { title: '有效期内添加同住人' }, name: 'addWithinValidityFamily', component: () => import('../views/residencePermitIntegral/addWithinValidityFamily/index.vue') },
            { path: '/otherApplications', permission: 'Pages.申请.快捷业务申请', icon: 'ios-flag', meta: { title: '其他申请' }, name: 'otherApplications', component: () => import('../views/residencePermitIntegral/otherApplications/next1.vue') },
            { path: '/renewalOfResidencePermit', permission: 'Pages.申请.续办申请', icon: 'ios-flag', meta: { title: '居住证续办' }, name: 'renewalOfResidencePermit', component: () => import('../views/residencePermitIntegral/renewalOfResidencePermit/index.vue') },
            { path: '/pointsArchivesSupplement', permission: '', icon: 'ios-flag', meta: { title: '档案补充材料' }, name: 'pointsArchivesSupplement', component: () => import('../views/residencePermitIntegral/pointsNewSupplement/archives.vue') },
            { path: '/pointsEducationSupplement', permission: '', icon: 'ios-flag', meta: { title: '最高学历补充材料' }, name: 'pointsEducationSupplement', component: () => import('../views/residencePermitIntegral/pointsNewSupplement/education.vue') },
            { path: '/pointsJuniorCollegeSupplement', permission: '', icon: 'ios-flag', meta: { title: '专科学历补充材料' }, name: 'pointsJuniorCollegeSupplement', component: () => import('../views/residencePermitIntegral/pointsNewSupplement/juniorCollege.vue') },
            
        ],
    }, {
        path: '/myApplication',
        name: 'myApplication',
        permission: '',
        meta: { title: '我提交的申请' },
        icon: 'md-barcode',
        component: main,
        children: [
            { path: '/myApplications', permission: 'Pages.查询.新办查询', icon: 'ios-flag', meta: { title: '积分新办查询' }, name: 'myApplications', component: () => import('../views/myApplications/index.vue') },
            { path: '/myApplicationsGR', permission: 'Pages.查询.新办个人查询', icon: 'ios-flag', meta: { title: '积分新办(个人申请)' }, name: 'myApplicationsGR', component: () => import('../views/myApplicationsGR/index.vue') },
            { path: '/myAddWithinApplications', permission: 'Pages.查询.添加同住人查询', icon: 'ios-flag', meta: { title: '有效期内添加同住人查询' }, name: 'myAddWithinApplications', component: () => import('../views/myAddWithinApplications/index.vue') },
            { path: '/myOtherApplications', permission: 'Pages.查询.快捷业务查询', icon: 'ios-flag', meta: { title: '其他申请查询' }, name: 'myOtherApplications', component: () => import('../views/myOtherApplications/index.vue') },
            { path: '/myRenewalApplications', permission: 'Pages.查询.续办查询', icon: 'ios-flag', meta: { title: '居住证续办查询' }, name: 'myRenewalApplications', component: () => import('../views/myRenewalApplications/index.vue') },
            { path: '/otherApplicationsDetail', permission: '', icon: 'ios-flag', meta: { title: '其他申请详情' }, name: 'otherApplicationsDetail', component: () => import('../views/otherApplicationsDetail/index.vue') },

        ],
    },
    {
        path: '/SpecialTalents',
        name: 'SpecialTalents',
        permission: '',
        meta: { title: '调档函下载' },
        icon: 'md-barcode',
        component: main,
        children: [
            { path: '/downloadTheFileAdjustmentLetter', permission: 'Pages.特殊人才下载调档函', icon: 'ios-flag', meta: { title: '调档函下载' }, name: 'downloadTheFileAdjustmentLetter', component: () => import('../views/specialTalents/downloadTheFileAdjustmentLetter.vue') },
       
        ],
    },

    // {
    //     path: '/system',
    //     name: 'system',
    //     permission: '',
    //     meta: { title: '系统管理' },
    //     icon: 'ios-construct',
    //     component: main,//serverSetting
    //     children: [
    //         { path: 'user', permission: 'Pages.Users', icon: 'ios-flag', meta: { title: '人员管理' }, name: 'user', component: () => import('../views/setting/user/user.vue') },
    //         { path: 'role', permission: 'Pages.Roles', icon: 'ios-flag', meta: { title: '角色管理' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
    //     ],
    // },

];
export const routers = [loginRouter, locking, ...externalDetail,...appRouters, otherRouters];
